import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const TicTacToe = () => {
  const [board, setBoard] = useState(Array(9).fill(null));
  const [userSymbol, setUserSymbol] = useState(null);
  const [computerSymbol, setComputerSymbol] = useState(null);
  const [isUserTurn, setIsUserTurn] = useState(false);
  const [winner, setWinner] = useState(null);
  const [gameStarted, setGameStarted] = useState(false);
const navigate=useNavigate()
  const winPatterns = [
    [0, 1, 2], [0, 3, 6], [0, 4, 8], [1, 4, 7],
    [2, 5, 8], [2, 4, 6], [3, 4, 5], [6, 7, 8],
  ];

  const checkWinner = (currentBoard) => {
    for (let pattern of winPatterns) {
      const [a, b, c] = pattern;
      if (
        currentBoard[a] &&
        currentBoard[a] === currentBoard[b] &&
        currentBoard[a] === currentBoard[c]
      ) {
        return currentBoard[a];
      }
    }
    return null;
  };





  const startGame = (selectedSymbol) => {
    const compSymbol = selectedSymbol === "X" ? "O" : "X";
    setUserSymbol(selectedSymbol);
    setComputerSymbol(compSymbol);
    setGameStarted(true);
    setIsUserTurn(selectedSymbol === "X");
  };

  const handleBoxClick = (index) => {
    if (board[index] || winner || !isUserTurn) return;

    const newBoard = [...board];
    newBoard[index] = userSymbol;
    setBoard(newBoard);
    
    const foundWinner = checkWinner(newBoard);
    if (foundWinner) {
      setWinner("User");
    } else if (!newBoard.includes(null)) {
      setWinner("Draw");
    } else {
      setIsUserTurn(false);
    }
  };

  useEffect(() => {
    if (!isUserTurn && !winner && gameStarted) {
      const timer = setTimeout(() => {
        const emptyIndices = board
          .map((val, idx) => (val === null ? idx : null))
          .filter((val) => val !== null);

        if (emptyIndices.length > 0) {
          const randomIndex = emptyIndices[Math.floor(Math.random() * emptyIndices.length)];
          const newBoard = [...board];
          newBoard[randomIndex] = computerSymbol;
          
          setBoard(newBoard);

          const foundWinner = checkWinner(newBoard);
          if (foundWinner) {
            setWinner("Computer");
          } else if (!newBoard.includes(null)) {
            setWinner("Draw");
          } else {
            setIsUserTurn(true);
          }
        }
      }, 700);

      return () => clearTimeout(timer);
    }
  }, [isUserTurn, winner, gameStarted, board, computerSymbol]);

  const resetGame = () => {
    setBoard(Array(9).fill(null));
    setWinner(null);
    setIsUserTurn(userSymbol === "X");
  };

  const fullReset = () => {
    setBoard(Array(9).fill(null));
    setUserSymbol(null);
    setComputerSymbol(null);
    setWinner(null);
    setGameStarted(false);
  };

  // Naya function Claim Points ke liye
  const handleClaimPoints = () => {

         navigate('/')


    // Yahan aap apna API call ya state update ka code likh sakte hain
    resetGame();
  };

  return (
    <div className="bg-[#0A192F] min-h-screen flex flex-col items-center justify-center font-sans relative">
      
      {/* STARTING MODAL */}
      {!gameStarted && (
        <div className="absolute inset-0 bg-black/60 flex items-center justify-center z-10 backdrop-blur-sm">
          <div className="bg-white p-8 rounded-2xl shadow-2xl flex flex-col items-center max-w-sm w-11/12">
            <h2 className="text-[#0A192F] text-3xl font-bold mb-2">Welcome!</h2>
            <p className="text-gray-600 mb-6 text-center">Choose your symbol to play against the Computer.</p>
            <div className="flex gap-6">
              <button
                onClick={() => startGame("X")}
                className="bg-[#0A192F] text-[#FFD700] text-4xl font-bold px-8 py-4 rounded-xl shadow-lg hover:scale-105 transition-transform"
              >
                X
              </button>
              <button
                onClick={() => startGame("O")}
                className="bg-[#FFD700] text-[#0A192F] text-4xl font-bold px-8 py-4 rounded-xl shadow-lg hover:scale-105 transition-transform"
              >
                O
              </button>
            </div>
            <p className="text-sm text-gray-500 mt-4">* 'X' always goes first.</p>
          </div>
        </div>
      )}

      {/* WINNER MODAL */}
      {winner && (
        <div className="absolute inset-0 bg-black/60 flex items-center justify-center z-10 backdrop-blur-sm">
          <div className="bg-white p-8 rounded-2xl shadow-2xl flex flex-col items-center max-w-sm w-11/12 text-center">
            <h2 className="text-4xl font-bold mb-2">
              {winner === "Draw" ? (
                <span className="text-gray-700">It's a Draw! 🤝</span>
              ) : winner === "User" ? (
                <span className="text-green-600">You Won! 🎉</span>
              ) : (
                <span className="text-red-600">Jhon Won! 🤖</span>
              )}
            </h2>
            <p className="text-gray-600 mb-8 mt-2 text-lg">
              {winner === "Draw" ? "Well played both sides." : winner === "User" ? "Great job defeating the AI! Collect your reward." : "Better luck next time!"}
            </p>
            
            <div className="flex gap-4">
              {/* Conditional Buttons based on User Win or Loss/Draw */}
              {winner === "User" ? (
                <button
                  onClick={handleClaimPoints}
                  className="bg-green-500 text-white px-6 py-2 rounded-lg font-bold shadow-md hover:bg-green-600 hover:scale-105 transition-all"
                >
                  Claim Points
                </button>
              ) : (
                <button
                  onClick={resetGame}
                  className="bg-[#0A192F] text-white px-6 py-2 rounded-lg font-semibold hover:bg-blue-900 transition-colors"
                >
                  Play Again
                </button>
              )}

              <button
                onClick={fullReset}
                className="bg-gray-200 text-gray-700 px-6 py-2 rounded-lg font-semibold hover:bg-gray-300 transition-colors"
              >
                Change Symbol
              </button>
            </div>
          </div>
        </div>
      )}

      {/* MAIN GAME BOARD */}
      <main className={`flex flex-col items-center ${!gameStarted || winner ? 'opacity-30 pointer-events-none' : ''} transition-opacity duration-300`}>
        <div className="text-center mb-8">
          <h1 className="text-[#FFD700] text-5xl font-extrabold tracking-wider mb-2 drop-shadow-md">
            TIC-TAC-TOE
          </h1>
          <p className="text-white text-lg h-6">
            {isUserTurn ? (
              <span className="text-green-400 font-semibold">Your Turn ({userSymbol})</span>
            ) : (
              <span className="text-red-400 font-semibold">Jhon is thinking...</span>
            )}
          </p>
        </div>
        
        <div className="grid grid-cols-3 gap-3 w-[70vmin] max-w-[400px] bg-white p-3 rounded-2xl shadow-[0_0_20px_rgba(255,215,0,0.2)]">
          {board.map((value, index) => (
            <button
              key={index}
              className={`aspect-square flex items-center justify-center rounded-xl text-6xl font-black shadow-inner transition-all duration-200 
                ${value === null 
                  ? "bg-gray-100 hover:bg-gray-200 cursor-pointer" 
                  : "bg-gray-50 cursor-default"
                }
                ${value === "X" ? "text-[#0A192F]" : "text-[#FFD700] drop-shadow-md"}
              `}
              onClick={() => handleBoxClick(index)}
              disabled={value !== null || !isUserTurn}
            >
              {value}
            </button>
          ))}
        </div>

        <button 
          className="bg-transparent text-white px-8 py-3 rounded-xl text-sm mt-10 opacity-70 hover:opacity-100 transition-opacity border border-white/30 hover:border-white"
          onClick={fullReset}
        >
          Reset Game
        </button>
      </main>
    </div>
  );
};

export default TicTacToe;